import 'css-chunksrc/client/pages/projectPage/kanbanPage/column/task/tagList/tag/styles.scss';export default {
  "tag": "_tag_1dufd_1",
  "removeIcon": "_removeIcon_1dufd_16",
  "slideRemoveIcon": "_slideRemoveIcon_1dufd_1"
};